// extracted by mini-css-extract-plugin
export default {"header__description":"Yj_XA","appear-from-above":"PWtGT","appearFromAbove":"PWtGT"};